import * as React from "react";
import { PublishedCalendarRow } from "./PublishedCalendarRow";

import { IPublishedCalendar } from "../../../classes/publishedCalendar";
import { IText_EventViews } from "../../../classes/text";

export interface IPublishedCalendarListProps {
    calendars: IPublishedCalendar[];
    eventViewText: IText_EventViews;
}

export const PublishedCalendarList = (props: IPublishedCalendarListProps) => {
    return (
        <div className="CAL-EVENT-cR-content">
            <ul className="CAL-EVENT-cR-list">    
            {   props.calendars.map((calendar) =>
                    <PublishedCalendarRow
                        key={calendar.id}
                        name={calendar.name}
                        category={calendar.category}
                        server={calendar.server}
                        isOriginatingSource={calendar.isOriginatingSource}
                        url={calendar.url}
                        eventViewText={props.eventViewText} />,
                )}            
            </ul>
        </div>
    );
};
